import { BreadcrumbInfo, TopBar } from "../../features/top/TopBar";
import { selectUser } from "../../redux/user/userSlice";
import { useSelector } from "react-redux";
import SchoolsList from "./SchoolsList";
import { retrieveSchools, selectSchools, schoolsSlice } from "../../redux/school/schoolsSlice";
import { useAppDispatch } from "../../app/hooks";
import { LoadState } from "../../redux/common";
import { useNavigate } from "react-router";
import { schoolInsUpdSlice } from "../../redux/school/schoolInsUpdSlice";
import PageAuthenticatedLoading from "../../features/pages/PageAuthenticatedLoading";
import { isTokenReady } from "../../features/user/UserAvatar";
import { ContextMenu, ContextMenuOptions } from "../../features/base/ContextMenu";
import MenuIcon from "@mui/icons-material/Menu";
import { checkIsAdmin } from "../../app/permissions";
import { routeSchoolNew } from "../../routes/school";

export function Init() {
    const user = useSelector(selectUser);
    const schools = useSelector(selectSchools);
    const dispatch = useAppDispatch();
    const admin = checkIsAdmin(user.priza.info);
    const navigate = useNavigate();

    const handleNewSchool = () => {
        dispatch(schoolInsUpdSlice.actions.clean());
        navigate(routeSchoolNew());
    };
    const handleRefresh = () => {
        dispatch(schoolsSlice.actions.clean());
    };

    const breadcrumbs: BreadcrumbInfo[] = [];

    const options: ContextMenuOptions[] = [];
    options.push({ label: "Atualizar", click: handleRefresh });
    if (admin) {
        options.push({ label: "Nova Escola", click: handleNewSchool });
    }
    const topMenu = <ContextMenu label={<MenuIcon />} options={options} />;

    if (schools.state.state == LoadState.NotStarted && isTokenReady(user))
        dispatch(retrieveSchools({}));

    return <PageAuthenticatedLoading
        topbar={<TopBar topMenu={topMenu} breadcrumbs={breadcrumbs} />}
        // topbar={{breadcrumbs: breadcrumbs, topMenu: topMenu}}
        loading={{
            states: [],
            content: () => { return <SchoolsList />; },
            error: "Erro ao carregar lista de escolas",
            retry: () => dispatch(retrieveSchools({}))
        }} />;
}
